/* RDG — QUESTIONNAIRE DE TAILLE (« Trouver ma taille »). Cree le 22/08/2026.
 *
 * ---------------------------------------------------------------------------
 * CE QUE FAIT CE FICHIER, ET CE QU'IL NE FAIT PAS
 * ---------------------------------------------------------------------------
 * Il lit une table de mensurations posee dans le panneau (recopie de
 * /pages/guide-des-tailles), lit les tailles REELLEMENT proposees par la fiche
 * produit ouverte, en deduit une taille, et coche le bouton radio correspondant
 * dans le selecteur de variantes du theme.
 *
 * Il ne soumet rien, n'envoie rien, ne pose aucun cookie. Les mensurations
 * restent dans une variable de cette page. La SEULE persistance possible est un
 * localStorage explicitement coche par la cliente (case decochee par defaut,
 * effacee des qu'elle la decoche) : voir la section MEMOIRE.
 *
 * L'ouverture et la fermeture du panneau ne sont PAS ici : c'est le socle de
 * tiroirs du theme (hdt-drawer + aria-controls) qui les fait, comme pour le
 * guide des tailles. Ce fichier ne s'en mele que pour les cas degrades.
 *
 * ---------------------------------------------------------------------------
 * LA REGLE DE DECISION, EN UNE PHRASE
 * ---------------------------------------------------------------------------
 * On interpole la mensuration dans la table pour obtenir une position continue
 * sur l'echelle 34-42, on retient LA PLUS LARGE des mesures donnees, on la
 * decale legerement selon la coupe demandee, puis on choisit la taille du
 * produit la plus proche de cette position.
 *
 * Deux points qui ne sont pas des details :
 *
 *  · LA PLUS LARGE GOUVERNE. Un vetement doit passer le point le plus large du
 *    corps. Une piece trop grande se porte ; une piece trop petite revient.
 *    Quand les mesures divergent de plus d'une taille et demie, on le DIT au
 *    lieu de le masquer — c'est exactement le cas ou une recommandation
 *    silencieuse produit un retour.
 *
 *  · ON N'INVENTE PAS DE PRECISION. La table s'arrete a 42. Au-dela, on
 *    prolonge le dernier ecart pour situer la cliente, mais le resultat le dit
 *    en toutes lettres. Idem sous le 34.
 *
 * ---------------------------------------------------------------------------
 * PIEGE PAYE PAR LA SESSION VOISINE, REPRIS TEL QUEL
 * ---------------------------------------------------------------------------
 * Cocher une taille depuis un panneau MODAL ne se fait pas avec .click() : le
 * <dialog> ouvert en showModal() rend le reste de la page inerte, et
 * l'activation d'un noeud inerte est neutralisee — le clic « marche » sans que
 * le selecteur du theme ne bouge. La sequence qui fonctionne (cocher un autre
 * bouton du groupe, puis le bon, puis emettre `change` a la main) a ete etablie
 * et mesuree le 21/08 dans assets/rdg-size-sheet.js. Elle est recopiee ici a
 * l'identique, y compris son detour par un pivot, qui n'est pas explique mais
 * est reproductible. Voir la fonction `cocher`.
 */
(function () {
  'use strict';
  if (window.__rdgSizeQuiz) return;
  window.__rdgSizeQuiz = true;

  var QUIZ_ID = 'RdgSizeQuiz';
  var CLE_MEMOIRE = 'rdg.quiz.v1';

  /* Plafond du filet d'etat final. Large a dessein : il doit couvrir la duree
     annoncee du geste (500 ms a l'ouverture, 400 a la fermeture) plus la marge
     d'un appareil lent, sans jamais interrompre une animation qui se deroule
     normalement. Repris de assets/rdg-guide.js. */
  var DUREE_MAX = 900;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function panneau() { return document.getElementById(QUIZ_ID); }

  /* -------------------------------------------------------------------- */
  /* Donnees posees par le snippet                                         */
  /* -------------------------------------------------------------------- */

  var TABLE = null;
  var T = null; /* chaines */

  function lireBloc(attr, hote) {
    var n = $('script[' + attr + ']', hote);
    if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  }

  /* `{x}`, `{y}`, `{m}` — rien d'autre n'est interprete, et le resultat part
     toujours dans textContent, jamais dans innerHTML. */
  function fmt(cle, vals) {
    var s = (T && T[cle]) || '';
    if (!vals) return s;
    return s.replace(/\{(x|y|m)\}/g, function (_, k) {
      return vals[k] === undefined || vals[k] === null ? '' : String(vals[k]);
    });
  }

  /* -------------------------------------------------------------------- */
  /* Echelle : du libelle d'une variante vers une position sur la table    */
  /* -------------------------------------------------------------------- */

  /* XXL est HORS TABLE (elle s'arrete au XL/42) — trois produits du catalogue
     en proposent un. On lui donne la position 5, dans le prolongement, et le
     resultat annonce qu'on est au-dela de la grille. Mieux vaut situer en le
     disant que refuser de repondre. */
  var LETTRES = { XS: 0, S: 1, M: 2, L: 3, XL: 4, XXL: 5 };

  var NUMERIQUES = null;  /* { '34': 0, ... } construit depuis la table */
  var COMBINEES = null;   /* { 'S/M': [0,2], 'M/L': [2,4] } */

  function construireEchelle() {
    NUMERIQUES = {};
    TABLE.echelle.forEach(function (e, i) { NUMERIQUES[String(e.fr)] = i; });
    COMBINEES = TABLE.combinees || {};
  }

  /* Rend { idx } pour une taille simple, { plage: [a, b] } pour une taille
     combinee, ou null si le libelle n'appartient pas a notre grille de
     vetement — pointures, « UNIQUE », libelle inedit. Un null quelque part
     suffit a basculer le panneau sur l'ecran « echelle non reconnue » : mieux
     vaut ne pas repondre que repondre a cote. */
  function resoudre(libelle) {
    var l = String(libelle || '').trim().toUpperCase().replace(/\s+/g, '');
    if (!l) return null;
    if (Object.prototype.hasOwnProperty.call(COMBINEES, l)) return { plage: COMBINEES[l] };
    if (Object.prototype.hasOwnProperty.call(LETTRES, l)) return { idx: LETTRES[l] };
    if (Object.prototype.hasOwnProperty.call(NUMERIQUES, l)) return { idx: NUMERIQUES[l] };
    return null;
  }

  /* Position continue d'une mensuration sur l'echelle. En dehors de la table,
     on PROLONGE le dernier ecart plutot que de plafonner : c'est ce qui permet
     de distinguer « juste au-dessus du 42 » de « tres au-dessus », donc de dire
     la bonne chose dans le resultat. */
  function position(valeur, cle) {
    var s = TABLE.echelle.map(function (e) { return e[cle]; });
    var n = s.length;
    if (valeur <= s[0]) return 0 - (s[0] - valeur) / Math.max(1, s[1] - s[0]);
    if (valeur >= s[n - 1]) return (n - 1) + (valeur - s[n - 1]) / Math.max(1, s[n - 1] - s[n - 2]);
    for (var i = 0; i < n - 1; i++) {
      if (valeur >= s[i] && valeur <= s[i + 1]) {
        return i + (valeur - s[i]) / Math.max(1, s[i + 1] - s[i]);
      }
    }
    return n - 1;
  }

  /* -------------------------------------------------------------------- */
  /* Etat de l'ouverture en cours                                          */
  /* -------------------------------------------------------------------- */

  /* Remis a zero a CHAQUE ouverture. Un panneau qui garderait les tailles du
     produit precedent cocherait une variante que la cliente n'a pas regardee —
     c'est la meme precaution que le sheet de taille. */
  var ctx = null;

  function neuf() {
    return { tailles: [], reco: null, etape: null, mode: 'mesures', guide: null };
  }

  /* Miroir : on relit les boutons radio A CHAQUE ouverture plutot que de les
     mettre en cache. Le theme reecrit ce fieldset quand la couleur change, donc
     un cache proposerait des tailles epuisees comme disponibles. */
  function lireTailles(selecteur) {
    var groupe = selecteur ? $(selecteur) : null;
    if (!groupe) return [];
    return $$('input[type="radio"][is-value]', groupe).map(function (input) {
      var cls = input.className || '';
      var r = resoudre(input.value);
      return {
        label: input.value,
        idx: r && r.idx !== undefined ? r.idx : null,
        plage: r && r.plage ? r.plage : null,
        connue: !!r,
        dispo: cls.indexOf('is-unavailable') === -1 && cls.indexOf('is-disabled') === -1,
        input: input
      };
    });
  }

  /* -------------------------------------------------------------------- */
  /* MEMOIRE — localStorage, sur consentement explicite seulement          */
  /* -------------------------------------------------------------------- */
  /* Pas un cookie : rien ne part sur le reseau, rien n'est lisible par un
     tiers, et la cle ne quitte pas l'appareil. La case est DECOCHEE par
     defaut, et la decocher efface immediatement. Des mensurations sont une
     donnee personnelle et un telephone se prete : le gain (ne pas retaper
     trois nombres sur la fiche suivante) ne justifie pas de decider a la
     place de la cliente. */

  function lireMemoire() {
    try {
      var brut = window.localStorage.getItem(CLE_MEMOIRE);
      return brut ? JSON.parse(brut) : null;
    } catch (e) { return null; }
  }
  function ecrireMemoire(o) {
    try { window.localStorage.setItem(CLE_MEMOIRE, JSON.stringify(o)); } catch (e) { /* mode prive, quota */ }
  }
  function effacerMemoire() {
    try { window.localStorage.removeItem(CLE_MEMOIRE); } catch (e) { /* idem */ }
  }

  /* -------------------------------------------------------------------- */
  /* Lecture des reponses                                                  */
  /* -------------------------------------------------------------------- */

  var CLES_MESURE = ['poitrine', 'taille', 'bassin'];

  function champ(dlg, cle) { return $('[data-rdg-quiz-m="' + cle + '"]', dlg); }

  function lireMesures(dlg) {
    var out = {};
    CLES_MESURE.forEach(function (cle) {
      var el = champ(dlg, cle);
      if (!el) return;
      var v = parseInt(String(el.value).replace(',', '.'), 10);
      out[cle] = isNaN(v) ? null : v;
    });
    return out;
  }

  /* Renvoie la liste des cles hors plage, et marque les champs concernes. Le
     marquage passe par un attribut sur la ligne (le <label>), pas par une
     couleur d'erreur : le site n'en a pas, et en inventer une pour trois champs
     serait une couleur de plus dans la DA. */
  function validerMesures(dlg) {
    var mauvaises = [];
    CLES_MESURE.forEach(function (cle) {
      var el = champ(dlg, cle);
      if (!el) return;
      var ligne = el.closest('.rdg-quiz__field');
      if (ligne) ligne.removeAttribute('data-rdg-quiz-err');
      if (el.value === '') return;
      var v = parseInt(el.value, 10);
      var min = parseInt(el.getAttribute('min'), 10);
      var max = parseInt(el.getAttribute('max'), 10);
      if (isNaN(v) || v < min || v > max) {
        mauvaises.push(cle);
        if (ligne) ligne.setAttribute('data-rdg-quiz-err', '');
      }
    });
    return mauvaises;
  }

  function lireCoupe(dlg) {
    var c = $('[data-rdg-quiz-coupe] input:checked', dlg);
    return c ? c.value : 'habituel';
  }

  function lireUsuel(dlg) {
    var u = $('[data-rdg-quiz-usuel] input:checked', dlg);
    return u ? parseInt(u.value, 10) : null;
  }

  /* -------------------------------------------------------------------- */
  /* Le calcul                                                             */
  /* -------------------------------------------------------------------- */

  function ecartA(entree, cible) {
    if (entree.plage) {
      if (cible < entree.plage[0]) return entree.plage[0] - cible;
      if (cible > entree.plage[1]) return cible - entree.plage[1];
      return 0;
    }
    return Math.abs(entree.idx - cible);
  }

  function borneBasse(e) { return e.plage ? e.plage[0] : e.idx; }
  function borneHaute(e) { return e.plage ? e.plage[1] : e.idx; }

  /* Choisit la taille du produit la plus proche d'une position.
     DEPARTAGE : a egalite on prend la PLUS GRANDE, sauf si la cliente a
     demande un porte pres du corps. Ce n'est pas arbitraire — trop petit ne se
     porte pas, trop grand se porte. C'est aussi ce qui tranche la charniere des
     tailles combinees, ou S/M et M/L sont a egalite parfaite au 38. */
  function choisir(tailles, cible, coupe) {
    var meilleur = null;
    tailles.forEach(function (e) {
      if (!e.connue) return;
      var d = ecartA(e, cible);
      if (!meilleur) { meilleur = e; return; }
      var dm = ecartA(meilleur, cible);
      if (d < dm - 0.0001) { meilleur = e; return; }
      if (Math.abs(d - dm) <= 0.0001) {
        var plusGrand = borneHaute(e) > borneHaute(meilleur);
        if (coupe === 'ajuste' ? !plusGrand : plusGrand) meilleur = e;
      }
    });
    return meilleur;
  }

  function laPlusProcheDispo(tailles, ref) {
    var d = null;
    tailles.forEach(function (e) {
      if (!e.connue || !e.dispo) return;
      if (!d) { d = e; return; }
      var a = Math.abs(borneHaute(e) - borneHaute(ref));
      var b = Math.abs(borneHaute(d) - borneHaute(ref));
      if (a < b) d = e;
    });
    return d;
  }

  function calculer(dlg) {
    var mesures = lireMesures(dlg);
    var coupe = lireCoupe(dlg);
    var usuel = lireUsuel(dlg);
    var tailles = ctx.tailles;

    /* Position de chaque mesure fournie. */
    var pos = [];
    if (ctx.mode === 'mesures') {
      CLES_MESURE.forEach(function (cle) {
        if (mesures[cle] === null || mesures[cle] === undefined) return;
        pos.push({ cle: cle, valeur: mesures[cle], p: position(mesures[cle], cle) });
      });
    }

    var base, source = null;
    if (pos.length) {
      /* LE POINT LE PLUS LARGE GOUVERNE. */
      source = pos.reduce(function (a, b) { return b.p > a.p ? b : a; });
      base = source.p;
    } else if (usuel !== null) {
      base = usuel;
    } else {
      return null;
    }

    var tilt = (TABLE.coupe && TABLE.coupe[coupe]) || 0;
    var cible = base + tilt;

    var choix = choisir(tailles, cible, coupe);
    if (!choix) return null;
    var sansCoupe = choisir(tailles, base, 'habituel');

    /* --- les nuances -------------------------------------------------- */
    var notes = [];

    /* Entre deux tailles : l'ecart residuel apres choix. Sur une taille
       combinee l'ecart est nul des qu'on est dans la plage, donc cette note ne
       s'y declenche jamais — c'est la note « charniere » qui prend le relais. */
    if (ecartA(choix, cible) >= 0.3) {
      /* Le voisin doit etre DU COTE OU PENCHE la cible, et strictement au-dela
         de la taille retenue. Une premiere version comparait les deux bornes
         hautes, ce qui designait M/L comme voisine de S/M pour une cliente
         situee SOUS le S/M — donc annoncait une hesitation entre deux tailles
         alors qu'elle etait hors grille par le bas. */
      var sens = cible > borneHaute(choix) ? 1 : (cible < borneBasse(choix) ? -1 : 0);
      var autre = null;
      if (sens !== 0) {
        tailles.forEach(function (e) {
          if (!e.connue || e === choix) return;
          var auDela = sens > 0 ? borneBasse(e) > borneHaute(choix) : borneHaute(e) < borneBasse(choix);
          if (!auDela) return;
          if (!autre || ecartA(e, cible) < ecartA(autre, cible)) autre = e;
        });
      }
      if (autre) {
        var bas = sens > 0 ? choix : autre;
        var haut = sens > 0 ? autre : choix;
        notes.push(fmt('noteEntre', { x: bas.label, y: haut.label }));
      }
    }

    /* Charniere des tailles combinees : la position ou S/M et M/L se
       chevauchent. C'est la seule chose vraiment utile a dire sur les 69
       produits vendus en tailles combinees. */
    var combinees = tailles.filter(function (e) { return e.connue && e.plage; });
    if (combinees.length > 1) {
      var chevauche = null;
      combinees.forEach(function (a) {
        combinees.forEach(function (b) {
          if (a === b) return;
          if (a.plage[1] === b.plage[0]) chevauche = a.plage[1];
        });
      });
      if (chevauche !== null && Math.abs(cible - chevauche) <= 0.35) {
        notes.push(fmt('noteCharniere'));
      }
    }

    /* Mesures divergentes : on le dit plutot que de le masquer. */
    if (pos.length > 1) {
      var mini = pos.reduce(function (a, b) { return b.p < a.p ? b : a; });
      if (source.p - mini.p >= 1.5) notes.push(fmt('noteEcart'));
    }

    /* La coupe a-t-elle change quelque chose ? */
    if (sansCoupe && sansCoupe.label !== choix.label) {
      notes.push(fmt('noteCoupe', { x: sansCoupe.label }));
    }

    /* Mesures et habitude en desaccord. */
    if (pos.length && usuel !== null) {
      var parHabitude = choisir(tailles, usuel, coupe);
      if (parHabitude && parHabitude.label !== choix.label) {
        notes.push(fmt('noteDesaccord', { x: choix.label, y: parHabitude.label }));
      }
    }

    /* DEUX BORDS DIFFERENTS, DEUX PHRASES DIFFERENTES.
     *
     * « La plus petite taille de ce modele » et « en dehors de notre grille »
     * ne veulent pas dire la meme chose, et les confondre produit une phrase
     * fausse. Mesure du 22/08 sur JEANS ELVIRA (S a XXL, sans XS) : un tour de
     * poitrine de 82 cm situe un 34 — qui EXISTE dans notre grille — et le
     * panneau annoncait pourtant « vos mesures sont en dessous de notre
     * grille ». Le probleme n'etait pas la grille, c'etait ce modele-la.
     *
     * On distingue donc :
     *   · le modele — la cliente est en dehors des tailles proposees ICI, et
     *     on lui dit ce que notre grille situerait pour elle ;
     *   · la grille — la cliente est en dehors de la table publiee, qui va du
     *     34 au 42 : la reponse devient une extrapolation, et on le dit.
     * Les deux peuvent tomber ensemble ; les phrases restent vraies separement.
     *
     * Le seuil de 0.4 evite de le dire pour un simple arrondi. */
    var connues = tailles.filter(function (e) { return e.connue; });
    if (connues.length) {
      var minB = Math.min.apply(null, connues.map(borneBasse));
      var maxB = Math.max.apply(null, connues.map(borneHaute));
      var horsModele = false;
      if (cible < minB - 0.4) { notes.push(fmt('noteModelePlusPetit')); horsModele = true; }
      if (cible > maxB + 0.4) { notes.push(fmt('noteModelePlusGrand')); horsModele = true; }

      /* Ce que la grille situerait, quand elle sait le dire. */
      var dernier = TABLE.echelle.length - 1;
      if (horsModele && cible >= -0.4 && cible <= dernier + 0.4) {
        var i = Math.min(dernier, Math.max(0, Math.round(cible)));
        var e = TABLE.echelle[i];
        notes.push(fmt('noteIdeal', { x: e.fr + ' (' + e.lettre + ')' }));
      }

      if (cible < -0.4) notes.push(fmt('noteSousGrille'));
      if (cible > dernier + 0.4) notes.push(fmt('noteSurGrille'));
    }

    /* Epuisee : on garde la recommandation vraie a l'ecran et on propose le
       repli separement. Recommander silencieusement une autre taille parce que
       la bonne manque, c'est fabriquer un retour. */
    var repli = null;
    if (!choix.dispo) {
      notes.push(fmt('noteEpuisee'));
      repli = laPlusProcheDispo(tailles, choix);
      if (repli) notes.push(fmt('noteRepli', { x: repli.label }));
    }

    notes.push(fmt('noteEcrire'));

    /* --- la phrase de justification ----------------------------------- */
    var parce;
    if (source) {
      var nom = fmt(source.cle === 'poitrine' ? 'mPoitrine' : source.cle === 'taille' ? 'mTaille' : 'mBassin');
      /* « votre mesure la plus large » ne se dit que si elle l'est VRAIMENT.
         Quand les trois mesures tombent sur la meme taille — le cas le plus
         frequent — la phrase designait arbitrairement la premiere en la
         presentant comme la plus large, ce qui est faux et se remarque. */
      var strictement = pos.length > 1 && pos.every(function (p) {
        return p === source || p.p < source.p - 0.05;
      });
      parce = fmt(strictement ? 'carMax' : 'carUne', { m: nom, x: source.valeur });
    } else {
      var libelleUsuel = TABLE.echelle[usuel] ? TABLE.echelle[usuel].fr : '';
      parce = fmt('carUsuel', { x: libelleUsuel });
    }

    return { choix: choix, repli: repli, notes: notes, parce: parce };
  }

  /* -------------------------------------------------------------------- */
  /* Cocher la taille dans le selecteur du theme                           */
  /* -------------------------------------------------------------------- */

  /* SEQUENCE ETABLIE PAR LA SESSION VOISINE (assets/rdg-size-sheet.js, 21/08),
     recopiee sans la modifier. Pas de .click() : le <dialog> modal rend la page
     inerte et l'activation d'un noeud inerte est neutralisee. Pas de garde
     « deja coche » non plus : sur cette fiche l'etat du DOM ment — le selecteur
     du theme reassigne la variante affichee vers un coloris qui possede une
     photo, et une garde sortait sans rien faire. Le detour par un pivot n'est
     pas explique ; il est reproductible, et le noter honnetement vaut mieux que
     de lui inventer une raison. */
  function cocher(input) {
    if (!input) return;
    var groupe = input.name ? document.getElementsByName(input.name) : [];
    var pivot = null;
    for (var i = 0; i < groupe.length; i++) {
      if (groupe[i] !== input) { pivot = groupe[i]; break; }
    }
    if (pivot) pivot.checked = true;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* -------------------------------------------------------------------- */
  /* Rendu des ecrans                                                      */
  /* -------------------------------------------------------------------- */

  function montrer(dlg, nom) {
    ctx.etape = nom;
    $$('[data-rdg-quiz-step]', dlg).forEach(function (s) {
      if (s.getAttribute('data-rdg-quiz-step') === nom) s.removeAttribute('hidden');
      else s.setAttribute('hidden', '');
    });

    var suivant = $('[data-rdg-quiz-next]', dlg);
    var retour = $('[data-rdg-quiz-back]', dlg);
    erreur(dlg, '');

    if (nom === 'impossible') {
      suivant.setAttribute('hidden', '');
      retour.setAttribute('hidden', '');
      return;
    }
    suivant.removeAttribute('hidden');
    suivant.removeAttribute('disabled');

    if (nom === 'mesures' || nom === 'reperes') {
      suivant.textContent = fmt('continuer');
      retour.setAttribute('hidden', '');
    } else if (nom === 'coupe') {
      suivant.textContent = fmt('voir');
      retour.removeAttribute('hidden');
    } else if (nom === 'resultat') {
      retour.removeAttribute('hidden');
      var cible = ctx.reco && (ctx.reco.repli || ctx.reco.choix);
      if (cible && cible.dispo) {
        suivant.textContent = fmt('choisir', { x: cible.label });
      } else {
        suivant.textContent = fmt('choisir', { x: cible ? cible.label : '' });
        suivant.setAttribute('disabled', '');
      }
      retour.textContent = fmt('recommencer');
    }

    /* Le corps redefile en haut a chaque etape : sur un telephone, l'ecran
       suivant s'ouvrait au milieu de la question precedente. */
    var corps = $('.rdg-quiz__body', dlg);
    if (corps) corps.scrollTop = 0;
  }

  function erreur(dlg, texte) {
    var el = $('[data-rdg-quiz-erreur]', dlg);
    if (!el) return;
    el.textContent = texte || '';
    if (texte) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  function rendreResultat(dlg) {
    var r = ctx.reco;
    $('[data-rdg-quiz-size]', dlg).textContent = r.choix.label;
    $('[data-rdg-quiz-because]', dlg).textContent = r.parce;

    var ul = $('[data-rdg-quiz-notes]', dlg);
    ul.textContent = '';
    r.notes.forEach(function (n) {
      if (!n) return;
      var li = document.createElement('li');
      li.textContent = n; /* jamais innerHTML : ces chaines viennent du snippet,
                             mais les valeurs interpolees viennent de champs. */
      ul.appendChild(li);
    });

    /* Le lien vers le guide n'apparait que si la fiche en a un. Un bouton qui
       n'ouvre rien serait pire que pas de bouton. */
    var g = $('[data-rdg-quiz-guide-btn]', dlg);
    if (g) {
      if (ctx.guide && document.getElementById(ctx.guide)) g.removeAttribute('hidden');
      else g.setAttribute('hidden', '');
    }
  }

  /* -------------------------------------------------------------------- */
  /* Preparation a l'ouverture                                             */
  /* -------------------------------------------------------------------- */

  function preparer(declencheur) {
    var dlg = panneau();
    if (!dlg || !TABLE) return;

    ctx = neuf();
    ctx.guide = declencheur.getAttribute('data-rdg-quiz-guide') || null;
    ctx.tailles = lireTailles(declencheur.getAttribute('data-rdg-quiz-mirror'));

    /* GARDE D'ECHELLE. Le declencheur n'est pas cense exister sur une fiche
       dont l'echelle nous echappe (la condition est posee en Liquid), mais le
       DOM a le dernier mot.
     *
     * IL FAUT QUE **TOUTES** LES VALEURS SOIENT RECONNUES, pas seulement deux.
     * Bug mesure au navigateur le 22/08 sur `basket-1158101` : les pointures
     * sont `36 · 37 · 38 · 39 · 40 · 41`, et 36, 38, 40 existent AUSSI dans
     * notre table de vetements. Une garde « au moins deux tailles connues »
     * passait donc, et le questionnaire proposait une pointure 38 a partir
     * d'un tour de poitrine. Rien ne le signalait.
     *
     * Le test « toutes connues » attrape les six pointures d'un coup (37, 39
     * et 41 n'etant dans aucune echelle de vetement), et attrape aussi les 35
     * fiches en taille UNIQUE et tout libelle inedit a venir. */
    var connues = ctx.tailles.filter(function (e) { return e.connue; });
    if (connues.length < 2 || connues.length !== ctx.tailles.length) {
      montrer(dlg, 'impossible');
      return;
    }

    /* Remise a zero des champs, PUIS relecture de la memoire. Sans la remise a
       zero, un panneau rouvert apres un « Recommencer » gardait les valeurs. */
    CLES_MESURE.forEach(function (cle) {
      var el = champ(dlg, cle);
      if (el) el.value = '';
      var ligne = el && el.closest('.rdg-quiz__field');
      if (ligne) ligne.removeAttribute('data-rdg-quiz-err');
    });
    var u = $('[data-rdg-quiz-usuel] input:checked', dlg);
    if (u) u.checked = false;
    var hab = $('[data-rdg-quiz-coupe] input[value="habituel"]', dlg);
    if (hab) hab.checked = true;

    var m = lireMemoire();
    var boite = $('[data-rdg-quiz-remember]', dlg);
    if (boite) boite.checked = !!m;
    if (m) {
      CLES_MESURE.forEach(function (cle) {
        var el = champ(dlg, cle);
        if (el && m[cle]) el.value = m[cle];
      });
      if (m.coupe) {
        var c = $('[data-rdg-quiz-coupe] input[value="' + m.coupe + '"]', dlg);
        if (c) c.checked = true;
      }
      if (m.usuel !== undefined && m.usuel !== null) {
        var v = $('[data-rdg-quiz-usuel] input[value="' + m.usuel + '"]', dlg);
        if (v) v.checked = true;
      }
      if (m.mode === 'reperes') ctx.mode = 'reperes';
    }

    ctx.reco = null;
    montrer(dlg, ctx.mode);
  }

  /* -------------------------------------------------------------------- */
  /* Enchainement                                                          */
  /* -------------------------------------------------------------------- */

  function suivant(dlg) {
    if (ctx.etape === 'mesures') {
      var mauvaises = validerMesures(dlg);
      if (mauvaises.length) { erreur(dlg, fmt('horsPlage')); return; }
      var m = lireMesures(dlg);
      var aucune = CLES_MESURE.every(function (c) { return m[c] === null || m[c] === undefined; });
      if (aucune) { erreur(dlg, fmt('manque')); return; }
      ctx.mode = 'mesures';
      montrer(dlg, 'coupe');
      return;
    }

    if (ctx.etape === 'reperes') {
      if (lireUsuel(dlg) === null) { erreur(dlg, fmt('manqueUsuel')); return; }
      ctx.mode = 'reperes';
      montrer(dlg, 'coupe');
      return;
    }

    if (ctx.etape === 'coupe') {
      var r = calculer(dlg);
      if (!r) { erreur(dlg, fmt('manque')); return; }
      ctx.reco = r;
      memoriser(dlg);
      rendreResultat(dlg);
      montrer(dlg, 'resultat');
      return;
    }

    if (ctx.etape === 'resultat') {
      var cible = ctx.reco && (ctx.reco.repli || ctx.reco.choix);
      if (!cible || !cible.dispo) return;
      cocher(cible.input);
      fermer(dlg);
    }
  }

  function retour(dlg) {
    if (ctx.etape === 'coupe') { montrer(dlg, ctx.mode); return; }
    if (ctx.etape === 'resultat') { ctx.reco = null; montrer(dlg, ctx.mode); }
  }

  function memoriser(dlg) {
    var boite = $('[data-rdg-quiz-remember]', dlg);
    if (!boite || !boite.checked) { effacerMemoire(); return; }
    var m = lireMesures(dlg);
    ecrireMemoire({
      poitrine: m.poitrine || null,
      taille: m.taille || null,
      bassin: m.bassin || null,
      coupe: lireCoupe(dlg),
      usuel: lireUsuel(dlg),
      mode: ctx.mode
    });
  }

  /* On demande la fermeture a l'HOTE `hdt-drawer` et non a la croix.
   *
   * La premiere version cliquait sur la croix. Ca marche, mais c'est un
   * TOGGLE : le socle du theme ouvre ou ferme selon l'etat courant, et un clic
   * arrive pendant que la fermeture se termine ROUVRE le panneau. Constate au
   * navigateur le 22/08 — un clic sur la croix, panneau deja referme, l'a
   * remis en `dialog-opening`. L'hote, lui, expose un `close()` qui ne fait que
   * fermer. Meme choix que assets/rdg-size-sheet.js.
   *
   * Le rendez-vous qui suit est le pendant du filet d'ouverture : si
   * l'animation de fermeture ne se resout pas, `dialog.close()` n'est jamais
   * appele et le panneau reste MODAL par-dessus une page devenue inerte —
   * le pire des deux defauts possibles.
   */
  function fermer(dlg) {
    if (!dlg.open) return;
    var hote = dlg.parentElement;
    if (hote && typeof hote.close === 'function') hote.close();
    else { try { dlg.close(); } catch (e) { /* deja ferme */ } }

    setTimeout(function () {
      if (!dlg.open) return;
      terminerLesAnimations(dlg);
      try { dlg.close(); } catch (e) { /* deja ferme entre-temps */ }
      dlg.classList.remove('dialog-closing', 'dialog-opening');
      dlg.style.removeProperty('transform');
      if (!document.querySelector('dialog[open]')) {
        document.documentElement.removeAttribute('scroll-lock');
      }
    }, DUREE_MAX);
  }

  /* -------------------------------------------------------------------- */
  /* Filet d'etat final — meme defaut que le guide, meme remede            */
  /* -------------------------------------------------------------------- */
  /* Le theme ouvre et ferme ses dialogues avec `await animation`, puis
     seulement ensuite retire la classe et appelle dialog.close(). L'animation
     passe par requestAnimationFrame, GELE des que la page n'est pas rendue
     (onglet en arriere-plan, tres normal sur un telephone) :
       · a l'ouverture, le panneau reste translate hors de l'ecran ;
       · a la fermeture, dialog.close() n'est jamais appele et le panneau reste
         modal par-dessus la page, qui n'est alors plus cliquable.
     Reproduit et mesure le 21/08 par la session du guide. setTimeout et non
     rAF, precisement parce que c'est rAF qui peut etre gele. */

  function terminerLesAnimations(dlg) {
    if (typeof dlg.getAnimations !== 'function') return;
    dlg.getAnimations().forEach(function (a) {
      try { a.finish(); } catch (e) { /* deja terminee, ou sans etat final */ }
    });
  }

  /* ETAT FINAL D'OUVERTURE, SANS PASSER PAR LA CLASSE.
   *
   * MESURE LE 22/08 sur ce panneau, et c'est un ECART avec assets/rdg-guide.js :
   * la version du guide ne finalise l'ouverture QUE si `dialog-opening` est
   * encore la. Or le theme retire cette classe des que SON `await animation`
   * rend la main — ce qui arrive tout de suite — pendant que l'animation Motion,
   * elle, reste gelee. Constate ici, panneau ouvert, `document.hidden === true` :
   * classe absente, `playState: "running"`, `currentTime` fige a 33,6 ms sur
   * 500, et un `transform: translateY(376.95px)` residuel qui laissait le
   * panneau a 377 px sous le bas de l'ecran. Le filet du guide ne se serait
   * jamais declenche.
   *
   * On arme donc, au clic sur le declencheur, un rendez-vous qui ne regarde que
   * le RESULTAT : panneau ouvert, animations terminees, transform enleve. En
   * fonctionnement normal il passe 400 ms apres la fin de l'animation et ne
   * change rien.
   */
  function poserEtatFinal(dlg) {
    if (!dlg.open) return;
    terminerLesAnimations(dlg);
    dlg.style.removeProperty('transform');
    dlg.classList.remove('dialog-opening');
  }

  function surveillerLEtat(dlg) {
    var minuteur = null;
    new MutationObserver(function () {
      var enCours = dlg.classList.contains('dialog-opening') || dlg.classList.contains('dialog-closing');
      if (!enCours) return;
      if (minuteur) clearTimeout(minuteur);
      minuteur = setTimeout(function () {
        minuteur = null;
        if (dlg.classList.contains('dialog-opening')) {
          poserEtatFinal(dlg);
        }
        if (dlg.classList.contains('dialog-closing')) {
          terminerLesAnimations(dlg);
          if (dlg.open) { try { dlg.close(); } catch (e) { /* deja ferme */ } }
          dlg.classList.remove('dialog-closing');
          dlg.style.removeProperty('transform');
          if (!document.querySelector('dialog[open]')) {
            document.documentElement.removeAttribute('scroll-lock');
          }
        }
      }, DUREE_MAX);
    }).observe(dlg, { attributes: true, attributeFilter: ['class'] });
  }

  /* -------------------------------------------------------------------- */
  /* Branchement                                                           */
  /* -------------------------------------------------------------------- */

  function demarrer() {
    var dlg = panneau();
    if (!dlg) return;

    TABLE = lireBloc('data-rdg-quiz-chart', dlg);
    T = lireBloc('data-rdg-quiz-i18n', dlg) || {};
    if (!TABLE || !TABLE.echelle || !TABLE.echelle.length) return;
    construireEchelle();
    ctx = neuf();

    /* PHASE DE CAPTURE. Le socle de tiroirs du theme ecoute lui aussi les clics
       sur [aria-controls] ; l'ordre entre deux ecouteurs de bulle n'est pas
       garanti, et le panneau doit etre rempli AVANT d'etre montre. */
    document.addEventListener('click', function (ev) {
      var t = ev.target.closest && ev.target.closest('[data-rdg-quiz]');
      if (!t) return;
      preparer(t);

      /* Filet d'ouverture : si le socle de tiroirs n'a pas repondu (script du
         theme absent ou en echec), on ouvre nous-memes. Le panneau reste
         utilisable, sans le piege de focus du theme. */
      setTimeout(function () {
        if (!dlg.open) { try { dlg.showModal(); } catch (e) { /* deja ouvert */ } }
      }, 350);

      /* Filet d'etat final, arme au clic et non sur la classe : voir la note de
         `poserEtatFinal`. C'est celui qui a rattrape le panneau reste 377 px
         sous l'ecran le 22/08. */
      setTimeout(function () { poserEtatFinal(dlg); }, DUREE_MAX);
    }, true);

    var bSuivant = $('[data-rdg-quiz-next]', dlg);
    var bRetour = $('[data-rdg-quiz-back]', dlg);
    if (!bSuivant || !bRetour) return;
    bSuivant.addEventListener('click', function () { suivant(dlg); });
    bRetour.addEventListener('click', function () { retour(dlg); });

    $$('[data-rdg-quiz-swap]', dlg).forEach(function (b) {
      b.addEventListener('click', function () {
        ctx.mode = b.getAttribute('data-rdg-quiz-swap');
        montrer(dlg, ctx.mode);
      });
    });

    /* Decocher efface tout de suite : une case qu'on decoche doit effacer, pas
       seulement cesser d'ecrire. */
    var boite = $('[data-rdg-quiz-remember]', dlg);
    if (boite) {
      boite.addEventListener('change', function () {
        if (boite.checked) memoriser(dlg);
        else effacerMemoire();
      });
    }

    /* Entree dans un champ = etape suivante, comme un formulaire. */
    $$('[data-rdg-quiz-m]', dlg).forEach(function (el) {
      el.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') { ev.preventDefault(); suivant(dlg); }
      });
      el.addEventListener('input', function () { erreur(dlg, ''); });
    });

    /* Choisir une pastille avance d'un cran quand il n'y a plus rien a saisir :
       sur l'ecran « coupe », c'est la derniere reponse. On NE le fait PAS sur
       la taille habituelle — une cliente peut vouloir corriger son choix avant
       de continuer, et un panneau qui saute sous le doigt est desagreable. */
    var groupeCoupe = $('[data-rdg-quiz-coupe]', dlg);
    if (groupeCoupe) {
      groupeCoupe.addEventListener('change', function () { erreur(dlg, ''); });
    }

    /* Le guide des tailles s'ouvre PAR-DESSUS ce panneau. En se fermant,
       DialogComponent.close() appelle removeTrapFocus(), qui est global : ce
       panneau, reste ouvert dessous, se retrouve sans piege de focus et la
       tabulation part se promener dans la page derriere. On le lui rend. */
    var guideBtn = $('[data-rdg-quiz-guide-btn]', dlg);
    if (guideBtn) {
      guideBtn.addEventListener('click', function () {
        var id = guideBtn.getAttribute('aria-controls');
        var guide = id && document.getElementById(id);
        if (!guide) return;
        guide.addEventListener('close', function () {
          if (!dlg.open) return;
          var hote = dlg.parentElement;
          if (hote && typeof hote.trapFocus === 'function') {
            try { hote.trapFocus(); } catch (e) { /* socle absent */ }
          }
        }, { once: true });
      });
    }

    surveillerLEtat(dlg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
